import { FormFieldTypes } from "../../../data/formFieldType";

const resetPasswordFormData = {
    name: "Reset Password Form",
    initialState: {
        password: "",
        confirmPassword: "",
    },
    formFields: [
        {
            id: "password",
            lable: "Enter New Password",
            Field_Name: "Password",
            fieldType: FormFieldTypes.PASSWORD,
            dataField: "password",
            fieldSetting: {
                placeholder: "Password",
            },
            style: {
                containerCss: "col-md-12 mb-4"
            },
            validation: [{ type: "require" }, { type: "password" }]
        },
        {
            id: "confirmPassword",
            lable: "Confirm New Password",
            Field_Name: "Confirm Password",
            fieldType: FormFieldTypes.PASSWORD,
            dataField: "confirmPassword",
            fieldSetting: {
                placeholder: "Confirm Password",
            },
            style: {
                containerCss: "col-md-12 mb-4"
            },
            validation: [
                { type: "require" },
                { type: "compare", compareEle: "password" }
            ]
        },
    ],
};
export default resetPasswordFormData;
